var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('img',{staticClass:"my-5",attrs:{"alt":"Gobi logo","src":require("../assets/gobi-full-logo.svg")}}),_c('hr'),(_vm.supportLvl >= 10)?_c('SetSupportLvl'):_vm._e(),_c('hr'),(_vm.supportLvl >= 1)?_c('Installer'):_vm._e(),_c('hr'),(_vm.supportLvl >= 1)?_c('MyAccounts'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }